<template lang="html">
  <div class="placed-backg" id="about-us-page">

    <section class="main-section" data-aos="fade-in" data-aos-duration="1000">
      <div class="placed-backg box-image"></div>

      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-5 col-xl-6 col-image"></div>

          <div class="col-lg-7 col-xl-6 col-text">
            <h1 class="mb-2 title">AVIP</h1>

            <!-- <h5 class="subtitle"></h5> -->
            <p>
              Bienvenido a AVIP, su opción confiable para el transporte de pasajeros. Nos especializamos en ofrecer un servicio de transporte seguro, cómodo y eficiente para grupos y viajeros individuales. Con una experiencia amplia en la industria y un compromiso inquebrantable con la satisfacción del cliente, estamos aquí para hacer que su experiencia de viaje sea inigualable.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="info-section">
      <div class="container oversized-container">
        <div class="box-plans">
          <h2 class="mb-1 text-center title-1" data-aos="fade-in">Nosotros</h2>

          <!-- <p class="p-md text-center">
            Nuestro plan mundial de cultivo de cáñamo ahora está activo y produce miles de kilogramos de aceite de CBD al por mayor fresco durante todo el año.
          </p> -->

          <div class="row row-plans">
            <div class="col-lg-6 col-plan" data-aos="fade-in" data-aos-duration="300">
              <h6 class="title">MISIÓN</h6>
              <p>
                En AVIP, nuestra misión es proporcionar un servicio de transporte de pasajeros excepcional, garantizando la seguridad, comodidad y puntualidad en cada viaje. Nos esforzamos por crear experiencias memorables para nuestros clientes, a través de un servicio profesional y una atención al detalle que asegure un viaje placentero y sin inconvenientes.
              </p>
            </div>

            <div class="col-lg-6 col-plan" data-aos="fade-in" data-aos-duration="500">
              <h6 class="title">VISIÓN</h6>
              <p>
                Ser la empresa de transporte de pasajeros líder en el sector, reconocida por nuestra excelencia en el servicio y compromiso con la satisfacción del cliente. Aspiramos a expandir nuestra red de servicios y mejorar continuamente nuestras operaciones, contribuyendo al desarrollo sostenible de las comunidades que servimos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {

  data() {
    return {
      aboutus: [
        { bgUrl: 'public/images/pages/about-us/IMG_4895.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4899.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4913.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4935.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4941.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4917.JPG'},
        { bgUrl: 'public/images/pages/about-us/IMG_4933.JPG'},
      ],


      aboutOptions: {
        loop:true,
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
      },

      history:{

      }
    };
  },
  methods: {
      gethistories: function(){
        axios.get(tools.url('/empresaFront')).then(
          ({data}) =>{
            this.history=data[this.$i18n.locale];
          });
      }
  },
  mounted() {
      this.gethistories();
  }
}
</script>
<style>
  @media screen and (max-width: 768px) {
    .slide-text h1 {
        font-size: 3em !important;
    }
    #project-description-section .swiper-container {
        height: 500px !important;
    }
    .center-vertical-obj {
        padding: 1.5em 0 !important;
    }
}
</style>
